import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import slugify from 'react-slugify'
import { Loading } from '../../features/Loading'

const StoreGroupLogo = ({ title, items, hasContent, isLoading }) => {
  return hasContent ? (
    <div className={`CategoryGroup col-12 pb-3 ${slugify(title, { delimiter: '-' })}`}>
      <h4 className='CategoryParent mb-1 txt-center'>{title}</h4>
      <div className='CategoryChilds row'>
        <Loading className='my-5' ready={!isLoading}>
          {items.map((item, ix) => (
            <div key={ix} className={`txt-center my-auto mx-auto col-xs-12 col-6 col-md-3 pt-half ${slugify(item.name, { delimiter: '-' })}`}>
              <p data-supplierId={item.supplierTypeId}>
                <Link
                  to={((item.customUrlPage !== undefined) && (item.customUrlPage !== null) ? item.customUrlPage : `/vendor?vendor=${item.supplierId}`)}
                  className='txt-body-sm color-ui-1'
                >
                  {
                    item.imageUrl
                      ? (
                        <img
                          className='my-3'
                          style={{ width: '70px', height: '50px' }}
                          src={item.imageUrl}
                        />
                      ) : (
                        <span>{item.name}</span>
                      )
                  }
                </Link>
              </p>
            </div>
          ))}
        </Loading>
      </div>
    </div>
  ) : (
    ''
  )
}

StoreGroupLogo.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  hasContent: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired
}
export default StoreGroupLogo



// WEBPACK FOOTER //
// ./src/features/Store/StoreGroupLogo.js